import styled, { css } from "styled-components";
import { done, primary } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";
import { thirdly4 } from "styles/theme";
import { bg } from "styles/theme";
import { gray } from "styles/theme";
import { dark, white } from "styles/theme";
import { borderRadius, fontSize } from "@mui/system";

const StatusCellStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    justifyContent: "center"
}));

export const CollapseButtonStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    justifyContent: "center"
}));


export const PerformAlertStyles = muiStyled(Box)(({ }) => ({
    '.checkbox-label': {
        color: "#00000080"
    },
    '.show-again-checkbox': {
        padding: "9px 9px 9px 0px"
    }
}));

export const PreformAssessmentStyles = muiStyled(Box)(({ overflow }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    '.preview-icon': {
        background: thirdly4,
        ':hover': {
            background: bg,
        }
    },
    '.play-icon': {
        width: 12,
        height: 12
    }
}));

export const AudioCheckButtonStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 8,
    padding: "8px 16px",
    borderRadius: 8,
    background: dark,
    color: white,
    cursor: "pointer",
    whiteSpace: "nowrap",
    fontSize: 16,
    lineHeight: 1,
    height: 35,
    boxSizing: "border-box",
    '&:hover': {
        opacity: 0.9
    },
    'i': {
        fontSize: 16,
        display: "inline-flex",
        alignItems: "center"
    }
}));

const headercss = css`
grid-template-columns: 120px 120px 120px 100px auto 130px 130px;
`


const WrapStatus = styled.span`
border:${props => props.border && `1px solid ${props.border}`};
padding: 4px 6px;
border-radius:8px;
text-align:center;
`

export { headercss, WrapStatus, StatusCellStyles }